import * as React from "react";
import type { GlobalConnectedProps } from "~/components/form/VariableLookup/VariableLookup";
import { withVariableLookup } from "~/components/form/VariableLookup/VariableLookup";
import type { TextProps } from "~/primitiveComponents/form/Text/Text";
import { DebounceText } from "~/primitiveComponents/form/Text/Text";

const TextWithInputRef = (props: TextProps & GlobalConnectedProps) => <DebounceText {...props} />;
export const VariableLookupText = withVariableLookup()(TextWithInputRef);
